import { lazy } from "react";
import { generateEncodedPath } from "../../utils/generateEncodedPath";
import type { Path } from "react-router-dom";
import type { AppRouteObject } from "../../routes";

const UserApprovalPage = lazy(() => import("../UserApprovalPage"));

export const UserApprovalRoute: AppRouteObject = {
  path: "/:realm/user-approval",
  element: <UserApprovalPage />,
  breadcrumb: (t) => t("titleUsers"),
  handle: {
    access: "query-users",
  },
};
